import { useSchool } from "components/FormFields";
import {
  SchoolArrivingOnsite,
  SchoolBillingDetails,
  SchoolDetails,
  SchoolProfileSummary,
  SchoolSitePolicies,
} from "components/Molecules";
import { Settings } from "luxon";
import { useParams } from "react-router-dom";

import { Loader } from "~components/Atoms";
import { SchoolClosures, SchoolYears } from "~components/Molecules";
import { COMBINED_RESTRICTIONS, useShouldRestrictAdmin } from "~utils";

export function SchoolPage() {
  /*** Hooks ***/
  const { schoolId } = useParams<{ schoolId: string }>();
  const isClassroomRequester = useShouldRestrictAdmin([COMBINED_RESTRICTIONS.CLASSROOM_ADMIN]);

  /*** Queries ***/
  const school = useSchool(schoolId);

  if (!school) return <Loader />;

  const {
    name,
    summary,
    websiteUrl,
    zip,
    state,
    streetAddress,
    city,
    dayOfContact,
    dayOfEmail,
    dayOfPhone,
    parkingCost,
    parkingLocation,
    checkInLocation,
    checkInProcedure,
    checkoutLocation,
    checkoutProcedure,
    subPolicies,
    studentPolicies,
    id,
    hours,
    tzString,
  } = school;

  if (tzString) {
    Settings.defaultZone = tzString;
  }

  return (
    <div className="page" css={{ paddingLeft: 16, paddingRight: 16 }}>
      <SchoolProfileSummary
        schoolId={id}
        websiteUrl={websiteUrl}
        summary={summary}
        name={name}
        address={{ zip, streetAddress, state, city }}
      />

      <SchoolDetails schoolId={id} hours={hours} />
      {!isClassroomRequester && (
        <SchoolBillingDetails
          schoolId={id}
          payRates={school.payRates}
          acceptedCredentials={school.acceptedCredentials}
        />
      )}

      <SchoolYears school={school} />
      <SchoolClosures school={school} />

      <SchoolArrivingOnsite
        schoolId={id}
        dayOfContact={dayOfContact}
        dayOfEmail={dayOfEmail}
        dayOfPhone={dayOfPhone}
        parkingCost={parkingCost}
        parkingLocation={parkingLocation}
        checkinLocation={checkInLocation}
        checkinProcedure={checkInProcedure}
        checkoutLocation={checkoutLocation}
        checkoutProcedure={checkoutProcedure}
      />
      <SchoolSitePolicies
        schoolId={id}
        subPolicies={subPolicies}
        studentPolicies={studentPolicies}
      />
    </div>
  );
}
